module.exports = __webpack_public_path__ + "img/htm-icon.07b7972b.svg";